export enum RightPlayerPanelTabType {
	Events = 'Events',
	Comments = 'Comments',
	Metadata = 'Metadata',
}

export const RightPlayerPanelTabsId = 'PlayerRightPanel'
